import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Load critical CSS first
import './styles/critical.css';
// Load optimized Bootstrap after critical CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/sw.js')
      .then(function(registration) {
        console.log('SW registered: ', registration);
      }, function(registrationError) {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const root = createRoot(document.getElementById('root'));

// Use StrictMode only in development for better production performance
const AppComponent = process.env.NODE_ENV === 'development' 
  ? <React.StrictMode><App /></React.StrictMode>
  : <App />;

root.render(AppComponent);

// Measure performance
reportWebVitals();